import React from 'react';

import partnerCrewConcept from '../../../main/assets/images/skydive/partner-logo-crewConcept.webp';
import partnerDroneLegends from '../../../main/assets/images/skydive/partner-logo-droneLegends.webp';
import partnerMilestoneC from '../../../main/assets/images/skydive/partner-logo-milestonec.webp';
import partnerUsdra from '../../../main/assets/images/skydive/partner-logo-usdra.webp';
import partnerWhoopers from '../../../main/assets/images/skydive/partner-logo-whoopers.webp';

export const LogosLayout = () => {
  return (
    <div className="skydive-logos-layout">
      <h2 className="skydive-logos-layout-title">Partners</h2>
      <div className="skydive-logos-layout-partners">
        <img
          src={partnerUsdra}
          alt="Unified Scholastic Drone Racing Association (USDRA) Logo"
          className="skydive-logos-layout-logo"
        />
        <img
          src={partnerCrewConcept}
          alt="CrewConcept Drone Lab Logo"
          className="skydive-logos-layout-logo"
        />
        <img
          src={partnerDroneLegends}
          alt="Drone Legends Logo"
          className="skydive-logos-layout-logo"
        />
        <img
          src={partnerMilestoneC}
          alt="Milestone C Logo"
          className="skydive-logos-layout-logo"
        />
        <img
          src={partnerWhoopers}
          alt="Wednesday Whoppers Logo"
          className="skydive-logos-layout-logo"
        />
      </div>
    </div>
  );
};
